module.exports = __webpack_public_path__ + "static/media/cardio_excercise_end.7942c512.mp3";